import { render, staticRenderFns } from "./ylkt6.vue?vue&type=template&id=6a272896&scoped=true&"
import script from "./ylkt6.vue?vue&type=script&lang=js&"
export * from "./ylkt6.vue?vue&type=script&lang=js&"
import style0 from "./ylkt6.vue?vue&type=style&index=0&id=6a272896&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a272896",
  null
  
)

export default component.exports